enum LogLevel {
  DEBUG = 'debug',
  INFO = 'info',
  WARN = 'warn',
  ERROR = 'error'
}

let logLevel: LogLevel = LogLevel.INFO

const logLevelByString: {[key: string]: LogLevel} = {
  'debug': LogLevel.DEBUG,
  'info': LogLevel.INFO,
  'warn': LogLevel.WARN,
  'error': LogLevel.ERROR
}

const logLevels = [
  LogLevel.DEBUG, 
  LogLevel.INFO,
  LogLevel.WARN,
  LogLevel.ERROR
]

const logLevelValues = {
  [LogLevel.DEBUG]: 1,
  [LogLevel.INFO]: 2,
  [LogLevel.WARN]: 3,
  [LogLevel.ERROR]: 5
}

if(!logLevels.includes(process.env.REACT_APP_LOG_LEVEL as LogLevel)){
  console.warn(`value ${process.env.REACT_APP_LOG_LEVEL} is not a recogized log level. Defaulting to info.`)
} else if (process.env.REACT_APP_LOG_LEVEL){
  logLevel = logLevelByString[process.env.REACT_APP_LOG_LEVEL]
}

var noop = function () {};

export default {
    debug : window.console && logLevelValues[logLevel] <= logLevelValues[LogLevel.DEBUG] &&window.console.debug && console.debug.bind(console) || noop,
    log : window.console && window.console.log && logLevelValues[logLevel] <= logLevelValues[LogLevel.INFO] && console.log.bind(console) || noop,
    info : window.console && window.console.log && logLevelValues[logLevel] <= logLevelValues[LogLevel.INFO] && console.log.bind(console) || noop,
    warn: window.console.warn && logLevelValues[logLevel] <= logLevelValues[LogLevel.WARN] && console.warn.bind(console) || noop,
    error:  window.console.error && logLevelValues[logLevel] <= logLevelValues[LogLevel.ERROR] && console.error.bind(console) || noop
};
  